<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-calendar w-5 h-5 group-hover:text-[#2AABEE] transition-colors text-gray-400"
    aria-hidden="true"
  >
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
  </svg>
</template>

<script setup>
// Calendar icon component
</script>

<style scoped>
.lucide-calendar {
  display: inline-block;
  vertical-align: middle;
  width: 1.25rem; /* w-5 */
  height: 1.25rem; /* h-5 */
  color: #9ca3af; /* text-gray-400 */
  transition: color 0.15s ease-in-out; /* transition-colors */
}

.group:hover .lucide-calendar {
  color: #2aabee; /* group-hover:text-[#2AABEE] */
}
</style>
